<elder-card-organizer
  class="full"
  [autoMoveCards]="true"
  [organizerModel]="cardData"
  (requestNewCard)="onNewCard($event)"
  (cardDropped)="onCardDrop($event)"
  (requestRemoveCard)="onRemoveCard($event)"
>
  <div *elderStackCard="let cd; let i = index" class="layout-row place-start-center gap-lg">
    <!-- Name -->
    <elder-localized-input name="{{ 'cd-nameI18n' + i }}" [(ngModel)]="cd.nameI18n">
    </elder-localized-input>

    <!-- Format Unit -->
    <mat-form-field>
      <elder-select
        name="{{ 'cd-unit' + i }}"
        allowNull
        [data]="unitList"
        [(ngModel)]="cd.formatSpec.unit"
        placeholder="{{ 'context.unit' | translate }}"
      >
      </elder-select>
    </mat-form-field>

    <!-- Resolve spec -->
    <app-item-property-resolve-spec-detail [resolveSpec]="cd.resolveSpec">
    </app-item-property-resolve-spec-detail>
  </div>
</elder-card-organizer>
